export default __webpack_public_path__ + "static/media/exit.10c38d0f.png";